import { GlobalOpportunity } from './classes/GlobalOpportunity.js';

document.addEventListener('DOMContentLoaded', () => {
  new GlobalOpportunity();
});

/*
import { ArcChart } from "./classes/ArcChart";
import { BarChartGroup } from "./classes/BarChartGroup";
import { MobileNav } from "../../js/classes/Helpers";

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll("[data-chart-arcs]").forEach((element) => {
    new ArcChart(element);
  });

  const groups = document.querySelectorAll("[data-horizontal-chart-group]");
  groups.forEach((group) => {
    new BarChartGroup(group, {
      placeholderColor: "var(--chart-bg, #EDDFD4)",
      fillerColor: "#EE6C5C",
      animationDuration: 0.6,
      animationDelay: 0.1,
      counterDuration: 1.5,
    });
  });

  const vGroups = document.querySelectorAll("[data-vertical-chart-group]");
  vGroups.forEach((group) => {
    new BarChartGroup(group, {
      placeholderColor: "var(--chart-bg, #EDDFD4)",
      fillerColor: "#EE6C5C",
      animationDuration: 0.6,
      animationDelay: 0.1,
      counterDuration: 1.5,
      type: "vertical"
    });
  });

  MobileNav();
});

 */
